module.exports = __webpack_public_path__ + "static/media/avatar-guest.bf9107cb.png";